import { Chip } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { PluginsContext } from '..';
import styles from './PluginDiv.module.scss';
import zip from 'jszip';

interface Props {
  file_uid: string;
  onSelection: (file_uid: string, value: boolean) => void;
}

interface PluginManifest {
  name: string;
  version: string;
  description: string;
  keywords?: string[];
}

const PluginDiv: React.FC<Props> = ({ file_uid, onSelection }) => {
  const { getPluginWithCache } = useContext(PluginsContext);
  const [plugin, setPlugin] = useState<PluginManifest>();
  useEffect(() => {
    (async () => {
      const cachedFile = await getPluginWithCache(file_uid);
      if (!cachedFile) return;
      const pluginFile = await zip.loadAsync(cachedFile.blob());
      const scriptBlob = await pluginFile
        .file('manifest.json')
        ?.async('string');
      if (!scriptBlob) return console.log('Manifest invalid');
      const parsed = JSON.parse(scriptBlob);
      setPlugin(parsed);
    })();
  }, [file_uid, getPluginWithCache]);
  const onCheckboxChange = (event: any) => {
    if (!event || !event.target) return;
    onSelection(file_uid, event.target.checked);
  };
  return (
    <tr>
      <td width="1%" className={styles.CheckboxTd}>
        <input type="checkbox" onChange={onCheckboxChange} />
      </td>
      <td>
        <div className={styles.PluginDivBody}>
          <div>
            {plugin?.name} {plugin?.version}
          </div>
          <>
            {plugin?.keywords?.map((e) => (
              <Chip label={e} />
            ))}
          </>
          <div>{plugin?.description}</div>
        </div>
      </td>
    </tr>
  );
};

export default PluginDiv;
